// extracted by mini-css-extract-plugin
export var box = "SliderControl-module--box--ad2a5";
export var box_md = "SliderControl-module--box_md--10c03";
export var box_xmd = "SliderControl-module--box_xmd--a51e3";
export var box_flex = "SliderControl-module--box_flex--05deb";
export var box_lg = "SliderControl-module--box_lg--c1228";
export var box_sm = "SliderControl-module--box_sm--9d276";
export var box_outer = "SliderControl-module--box_outer--a9574";
export var box_whiteBg = "SliderControl-module--box_white-bg--fa903";
export var box_noMarginBottom = "SliderControl-module--box_no-margin-bottom--f17da";
export var box_noPadding = "SliderControl-module--box_no-padding--914d4";
export var box_outerGray = "SliderControl-module--box_outer-gray--c7a42";
export var box_dark = "SliderControl-module--box_dark--55629";
export var box_zIndex = "SliderControl-module--box_z-index--5a40b";
export var box_zIndex6 = "SliderControl-module--box_z-index-6--5293a";
export var box_eventsWithLine = "SliderControl-module--box_events-with-line--a9372";
export var box_featuresAo = "SliderControl-module--box_features-ao--f854f";
export var box_verticalPaddings = "SliderControl-module--box_vertical-paddings--e4acd";
export var clearP = "SliderControl-module--clearP--b8bdf";
export var clearP_vc = "SliderControl-module--clearP_vc--9a582";
export var controlsWrapper = "SliderControl-module--controlsWrapper--05d01";
export var text = "SliderControl-module--text--3efe7";
export var noOrder = "SliderControl-module--noOrder--0fd22";
export var office = "SliderControl-module--office--3f727";
export var buttonsWrapper = "SliderControl-module--buttonsWrapper--4fb4d";
export var button = "SliderControl-module--button--8e879";
export var fadeInAnimation = "SliderControl-module--fadeInAnimation--7a236";
export var placeHolderShimmer = "SliderControl-module--placeHolderShimmer--28300";